import { useContext } from "react"
import { CurrentGroupContext } from "source/groups/my/groups"
import TabView from "source/groups/my/groups/TabView"
import { Icon } from "source/shared/components"
import { Heading } from "@planningcenter/doxy-web"
import { Link, Navigate } from "react-router-dom"
import { usePcoChatEnabled } from "source/chat/hooks/usePcoChatEnabled"

export default function ChatIndex() {
  const group = useContext(CurrentGroupContext)
  const chatEnabled = group.abilities.conversations.can_read
  const pcoChatEnabled = usePcoChatEnabled()
  const hasAccess = chatEnabled && pcoChatEnabled
  const chatGroupGraphId = `Groups-Group-${group.id}`
  const chatDrawerFragmentRoute = `#chat=/?filter=${chatGroupGraphId}`

  if (!hasAccess) return <Navigate to={group.base_path} replace />

  return (
    <TabView>
      <section>
        <div className="d-f fd-c g-1 ai-c jc-c c-tint2 mt-8@md mt-4">
          <Icon symbol="general#text-message" className="fs-0" aria-hidden />
          <Heading
            text="Chat with your group!"
            level={2}
            size={2}
            color="tint2"
          />
          <p className="ta-c" style={{ maxWidth: 400 }}>
            {
              "Open Chat filtered to this group via the ‘Chat with group’ button. Use the icon in the header to see all your conversations or jump back to what you were doing last."
            }
          </p>
          <Link
            to={chatDrawerFragmentRoute}
            onClick={(e) => {
              e.preventDefault()
              window.location.hash = chatDrawerFragmentRoute
            }}
            className="minor-btn secondary-btn btn"
            aria-label="Chat with group"
          >
            <Icon symbol="general#text-message" className="mr-4p" aria-hidden />
            Chat with group
          </Link>
        </div>
      </section>
    </TabView>
  )
}
